import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ITServices from './components/ITServices';
import NetSuiteERP from './components/NetSuiteERP';
import Ourservices from './components/OurServices';
import Industries from './components/industries';
import HowWeHelp from './components/HowWeHelp';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import NetSuiteServices from './components/NetSuiteServices';
import NetSuiteImplementation from './components/NetSuiteImplementation';
import NetSuiteStaffingPage from './components/NetsuiteStaffing';
import NetSuiteSupportPage from './components/NetSuiteSupportPage';
import NetSuiteERPLanding from './components/NetSuiteERPLanding';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import CookiePolicy from './components/CookiePolicy';
import NetSuiteCRM from './components/NetSuiteCRM';
import NetSuiteTrainingAdvisory from './components/NetSuiteTrainingAdvisory';
import Careers from './components/Careers';
import NetSuiteEcommerce from './components/NetSuiteEcommercePage';
import AboutUs from './components/AboutUs';
import IndustriesPage from './components/IndustriesPage';
import RetailEcommercePage from './components/RetailEcommercePage';
import HealthcarePage from './components/HealthcarePage';
import ManufacturingPage from './components/ManufacturingPage';
import ContactUs from './components/ContactUs';
import FinanceAccountingPage from './components/FinanceAccountingPage';
import WholesaleDistributionPage from './components/WholesaleDistributionPage';
import ITSoftwarePage from './components/ITSoftwarePage';
import ThankYou from './components/ThankYou';
import ScrollToTop from './components/ScrollToTop';
import ProductsPage from './components/ProductsPage';
import LegalEntity from './components/LegalEntity';
import ProductsTeaser from './components/ProductsTeaser';
import Blog from './components/Blog';
import BlogDetail from './components/BlogDetail';

// Home page component
const HomePage = () => (
  <>
    <Helmet>
      <title>NetSuite Services USA | SpireNest ERP Solutions</title>
      <link rel="canonical" href="https://spirenest.co/" />
      <meta name="description" content="SpireNest offers expert NetSuite implementation, customization, and support services across the USA, streamlining your business operations efficiently." />
      <meta name="keywords" content="NetSuite, ERP, CRM, managed services, USA, business solutions, SpireNest" />
      <meta property="og:title" content="SpireNest | NetSuite Services for Smarter ERP Implementation" />
      <meta property="og:description" content="Unlock the full power of NetSuite with SpireNest. We help US businesses with tailored NetSuite implementation, support, and integration." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://spirenest.co/" />
      <meta property="og:image" content="https://spirenest.co/assets/images/og-home.jpg" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="SpireNest | NetSuite Services for Smarter ERP Implementation" />
      <meta name="twitter:description" content="Expert NetSuite implementation, customization, and support services built for growth." />
      <meta name="twitter:image" content="https://spirenest.co/assets/images/og-home.jpg" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebPage",
              "@id": "https://spirenest.co/",
              "name": "SpireNest | NetSuite Services for Smarter ERP Implementation",
              "description": "Unlock the full power of NetSuite with SpireNest. We help US businesses with tailored NetSuite implementation, support, and integration.",
              "url": "https://spirenest.co/",
              "image": "https://spirenest.co/assets/images/og-home.jpg",
              "publisher": {
                "@type": "Organization",
                "name": "SpireNest",
                "url": "https://spirenest.co/",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://spirenest.co/assets/logo-Cko-LaIl.png"
                }
              }
            },
            {
              "@type": "BreadcrumbList",
              "@id": "https://spirenest.co/#breadcrumb",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://spirenest.co/"
                }
              ]
            }
          ]
        })}
      </script>
    </Helmet>
    <Hero />
    <ITServices />
    <NetSuiteERP />
    <Ourservices />
    <ProductsTeaser />
    <Industries />
    <HowWeHelp />
    <FAQSection />
  </>
);

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/netsuite/services" element={<NetSuiteServices />} />
        <Route path="/netsuite/services/implementation" element={<NetSuiteImplementation />} />
        <Route path="/netsuite/services/staffing" element={<NetSuiteStaffingPage />} />
        <Route path="/netsuite/services/support" element={<NetSuiteSupportPage />} />
        <Route path="/netsuite/services/erp" element={<NetSuiteERPLanding />} />
        <Route path="/netsuite/services/financial" element={<NetSuiteTrainingAdvisory />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/netsuite/services/crm" element={<NetSuiteCRM />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/netsuite/services/ecommerce" element={<NetSuiteEcommerce />} />
        <Route path="/netsuite/industries" element={<IndustriesPage />} />
        <Route path="/netsuite/industries/manufacturing" element={<ManufacturingPage />} />
        <Route path="/netsuite/industries/retail-ecommerce" element={<RetailEcommercePage />} />
        <Route path="/netsuite/industries/healthcare" element={<HealthcarePage />} />
        <Route path="/netsuite/industries/finance-accounting" element={<FinanceAccountingPage />} />
        <Route path="/netsuite/industries/wholesale-distribution" element={<WholesaleDistributionPage />} />
        <Route path="/netsuite/industries/it-software" element={<ITSoftwarePage />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/legal" element={<LegalEntity />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;